import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const AltStockContent = ({ stockNumber }) => {
	const labels = useLabels();
	const stockLabel = labels.get('STOCK');

	return stockNumber ? (
		<span className="text-muted mr-4 ddc-font-size-xsmall">
			{stockLabel}# {stockNumber}
		</span>
	) : null;
};

AltStockContent.propTypes = {
	stockNumber: PropTypes.string
};

export default AltStockContent;
